export default {
    mailings(state) {
        return state.mailings;
    },
    mailchimpTemplates(state) {
        return state.mailchimpTemplates;
    }
}